<template lang="pug">
  .box-pagination(:style="screenExercise ? 'display: block;' : ''")
    .pagination-show(:style="screenExercise ? 'padding-right: 0px; text-align: center; font-size: 12px; padding-bottom: 8px;' : ''")
      | {{showPagination()}}
    .pagination-page
      ul.pagination-custom(v-if="!noLiSurround")
        li.pagination-item
          a.material-icons(@click="selectFirstPage()") first_page
        li.pagination-item(v-if="!(firstPageSelected() && hidePrevNext)" :class="[prevClass, firstPageSelected() ? disabledClass : '']")
          a.material-icons(@click="prevPage()" :class="prevLinkClass" :tabindex="firstPageSelected() ? -1 : 0") chevron_left
        li.pagination-item(v-for="page in pages" :class="[pageClass, page.selected ? activeClass : '', page.disabled ? disabledClass : '', page.breakView ? breakViewClass: '']")
          a.page-link(v-if="page.breakView" :class="[pageLinkClass, breakViewLinkClass]")
            slot(name="breakViewContent") {{ breakViewText }}
          a.page-link(v-else-if="page.disabled" :class="pageLinkClass") {{ page.content }}
          a.page-link(v-else @click="handlePageSelected(page.index + 1)" :class="pageLinkClass") {{ page.content }}
        li.pagination-item(v-if="!(lastPageSelected() && hidePrevNext)" :class="[nextClass, lastPageSelected() ? disabledClass : '']")
          a.material-icons(@click="nextPage()"  :class="nextLinkClass") chevron_right
        li.pagination-item
          a.material-icons(@click="selectLastPage()") last_page
      div(:class="containerClass" v-else)
        a(v-if="firstLastButton" @click="selectFirstPage()"  :class="[pageLinkClass, firstPageSelected() ? disabledClass : '']" )
        a(v-if="!(firstPageSelected() && hidePrevNext)" @click="prevPage()"  :class="[prevLinkClass, firstPageSelected() ? disabledClass : '']")
        <template v-for="page in pages">
          a(v-if="page.breakView" :class="[pageLinkClass, breakViewLinkClass, page.disabled ? disabledClass : '']" )
            slot(name="breakViewContent") {{ breakViewText }}
          a(v-else-if="page.disabled" :class="[pageLinkClass, page.selected ? activeClass : '', disabledClass]") {{ page.content }}
          a(v-else @click="handlePageSelected(page.index + 1)"  :class="[pageLinkClass, page.selected ? activeClass : '']") {{ page.content }}
        </template>
        a(v-if="!(lastPageSelected() && hidePrevNext)" @click="nextPage()" :class="[nextLinkClass, lastPageSelected() ? disabledClass : '']")
        a(v-if="firstLastButton" @click="selectLastPage()" :class="[pageLinkClass, lastPageSelected() ? disabledClass : '']")
</template>

<script>
export default {
  props: {
    currentPage: {
      type: Number
    },
    pageRange: {
      type: Number,
      default: 3
    },
    marginPages: {
      type: Number,
      default: 1
    },
    prevText: {
      type: String,
      default: 'Prev'
    },
    nextText: {
      type: String,
      default: 'Next'
    },
    breakViewText: {
      type: String,
      default: '…'
    },
    containerClass: {
      type: String
    },
    pageClass: {
      type: String
    },
    pageLinkClass: {
      type: String
    },
    prevClass: {
      type: String
    },
    prevLinkClass: {
      type: String
    },
    nextClass: {
      type: String
    },
    nextLinkClass: {
      type: String
    },
    breakViewClass: {
      type: String
    },
    breakViewLinkClass: {
      type: String
    },
    activeClass: {
      type: String,
      default: 'active'
    },
    disabledClass: {
      type: String,
      default: 'disabled'
    },
    noLiSurround: {
      type: Boolean,
      default: false
    },
    firstLastButton: {
      type: Boolean,
      default: false
    },
    firstButtonText: {
      type: String,
      default: 'First'
    },
    lastButtonText: {
      type: String,
      default: 'Last'
    },
    hidePrevNext: {
      type: Boolean,
      default: false
    },
    totalItems: {
      type: Number
    },
    itemsPerPage: {
      type: Number,
      default: 8
    },
    screenExercise: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    start () {
      return (this.currentPage - 1) * this.itemsPerPage
    },
    end () {
      let end = this.start + this.itemsPerPage
      return this.totalItems < end ? this.totalItems : end
    },
    pageCount() {
      if (this.itemsPerPage === 0) {
        return 0
      }
      return Math.ceil(this.totalItems / this.itemsPerPage)
    },
    pages() {
      let items = {}
      // console.log(this.pageCount, this.pageRange, this.currentPage)
      if (this.pageCount <= this.pageRange) {
        for (let index = 0; index < this.pageCount; index++) {
          let page = {
            index: index,
            content: index + 1,
            selected: index === (this.currentPage - 1)
          }
          items[index] = page
        }
      } else {
        const halfPageRange = Math.floor(this.pageRange / 2)
        let setPageItem = index => {
          let page = {
            index: index,
            content: index + 1,
            selected: index === (this.currentPage - 1)
          }

          items[index] = page
        }

        let setBreakView = index => {
          let breakView = {
            disabled: true,
            breakView: true
          }
          items[index] = breakView
        }
        // 1st - loop thru low end of margin pages
        for (let i = 0; i < this.marginPages; i++) {
          setPageItem(i)
        }

        // 2nd - loop thru selected range
        let selectedRangeLow = 0
        if (this.currentPage - halfPageRange > 0) {
          selectedRangeLow = this.currentPage - 1 - halfPageRange
        }

        let selectedRangeHigh = selectedRangeLow + this.pageRange - 1
        if (selectedRangeHigh >= this.pageCount) {
          selectedRangeHigh = this.pageCount - 1
          selectedRangeLow = selectedRangeHigh - this.pageRange + 1
        }

        for (let i = selectedRangeLow; i <= selectedRangeHigh && i <= this.pageCount - 1; i++) {
          setPageItem(i)
        }

        // Check if there is breakView in the left of selected range
        if (selectedRangeLow > this.marginPages) {
          setBreakView(selectedRangeLow - 1)
        }

        // Check if there is breakView in the right of selected range
        if (selectedRangeHigh + 1 < this.pageCount - this.marginPages) {
          setBreakView(selectedRangeHigh + 1)
        }

        // 3rd - loop thru high end of margin pages
        for (let i = this.pageCount - 1; i >= this.pageCount - this.marginPages; i--) {
          setPageItem(i)
        }
      }
      return items
    }
  },
  methods: {
    showPagination() {
      if (this.totalItems === 0) return this.$t('pagination.show_info_none')
      else return this.$t('pagination.show_info').replace('{0}', this.start + 1).replace('{1}', this.end).replace('{2}', this.totalItems)
    },
    handlePageSelected(selected) {
      if (this.currentPage === selected) return
      this.$emit('pageChange', selected)
    },
    prevPage() {
      if (this.currentPage <= 1) return
      this.handlePageSelected(this.currentPage - 1)
    },
    nextPage() {
      if (this.currentPage >= this.pageCount) return
      this.handlePageSelected(this.currentPage + 1)
    },
    firstPageSelected() {
      return this.currentPage === 1
    },
    lastPageSelected() {
      return (this.currentPage === this.pageCount) || (this.pageCount === 0)
    },
    selectFirstPage() {
      if (this.currentPage <= 1) return
      this.handlePageSelected(1)
    },
    selectLastPage() {
      if (this.currentPage >= this.pageCount) return
      this.handlePageSelected(this.pageCount)
    }
  }
}
</script>
<style lang="scss">
.box-pagination{display: flex;
  .pagination-show{padding-right: 20px;}
  .pagination-page{display: flex;flex-grow: 1; justify-content: center;
    .pagination-custom { list-style-type: none; margin: 0; padding: 0;
        .pagination-item { float: left; width: 30px; height: 30px; text-align: center;
          &:last-child{margin-right: 0;}
          a{cursor:pointer; border: 0 none; background: transparent; color:#343A40; line-height: 30px; font-weight: 500;
            &.page-link{color: #9B9B9B;}
          }
          &.active{background: #FFD311 0% 0% no-repeat padding-box; border-radius: 5px; color:#343A40; text-align: center;
            a{color:#343A40;}
          }
          a[disabled="disabled"]{color:#9B9B9B;}
        }
    }
  }
}
@media (max-width: 1366px){
}
@media (max-width: 1024px){
}
@media (max-width: 991px){
}
@media (max-width: 768px){
}
@media (max-width: 375px){
}
</style>



// WEBPACK FOOTER //
// index.vue?4839e600